<template>
  <div class="axes-figuration">
    <h2 class="subtitle">Options du site internet</h2>
    <hr />
    <axes_text />
    <hr />
    <axes_figuration></axes_figuration>
    <hr />
    <violet-bar>Contenu détaillé des axes</violet-bar>
    <div class="box has-background-light" v-if="axes_map">
      <div class="columns is-multiline">
        <div class="squarebox column is-full" :key="axe.id" v-for="axe in axes">
          <div v-if="typeof axes_map[axe.id] !== 'undefined'">
            <h3 class="subtitle">{{ axe.name }}</h3>
            <div class="field">
              <label for="" class="label checkbox"
                >Préserver les séries d'images :
                <input
                  type="checkbox"
                  class=""
                  v-model="axes_map[axe.id].preserve_series"
              /></label>
            </div>
            <div class="field">
              <label for="" class="label"
                >Texte de présentation de l'axe :</label
              >
              <textarea
                type="textarea"
                class="textarea is-small is-small"
                v-model="axes_map[axe.id].text"
              ></textarea>
            </div>
            <div class="field">
              <label for="" class="label"
                >Images de référence (<button
                  class="button is-small"
                  @click="add_picture_to(axes_map[axe.id])"
                >
                  Ajouter
                </button>
                ):</label
              >
              <div class="box">
                <axe-edit-picture
                  v-for="(p, index) in axes_map[axe.id].picture_series"
                  :key="p.id"
                  :total="axes_map[axe.id].picture_series.length"
                  :index="index"
                  @up="move_pic_up(axes_map[axe.id], index)"
                  @down="move_pic_down(axes_map[axe.id], index)"
                  @update="update_pic(axes_map[axe.id], index, $event)"
                  @delete="delete_pic(axes_map[axe.id], index)"
                  :picture="axes_map[axe.id].picture_series[index]"
                ></axe-edit-picture>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="button button is-primary"
      :class="{ 'is-loading': loading }"
      @click="save"
    >
      Enregistrer
    </div>
  </div>
</template>
<script>
import VioletBar from "../Projects/VioletBar";
import { types } from "../../store/actions/kv";
import { types as ltypes } from "../../store/actions/misc";
import Axes_figuration from "./Axes_figuration";
import Axes_text from "./Axes_text";
import VueDraggable from "vuedraggable";
import AxeEditPicture from "../Projects/Edit/AxeEditPicture.vue";
import { PictureForContentBlock } from "../../store/models/project";

export default {
  name: "axes_travail",
  components: {
    Axes_text,
    Axes_figuration,
    VioletBar,
    VueDraggable,
    AxeEditPicture,
  },
  data() {
    return {
      loading: false,
      axes: [],
      axes_map: null,
    };
  },
  methods: {
    async fetch() {
      const axes = await this.$store.dispatch(types.GET_KV, "axes");
      this.axes = axes;
      try {
        const a = await this.$store.dispatch(ltypes.GET_AXES_DETAILS);
        this.axes_map = this.upgrade_axes_map(a, axes);
      } catch (e) {
        this.axes_map = this.upgrade_axes_map({}, axes);
      }
    },
    upgrade_axes_map(map, axes) {
      return axes.reduce((out, a) => {
        if (typeof map[a.id] === "undefined") {
          out[a.id] = {text: "",
            preserve_series: false,
            picture_series: []};
            return out;
        } else {
          out[a.id] = map[a.id];
          return out;
        }
      }, {__WITH_PICTURES__: 1});
    },
    add_picture_to(axe) {
      axe.picture_series.push(PictureForContentBlock());
    },
    move_pic_up(axe, pic_index) {
      this.movePic(axe, pic_index, -1);
    },
    move_pic_down(axe, pic_index) {
      this.movePic(axe, pic_index, 1);
    },
    movePic(axe, pic_index, d) {
      const c = axe;
      c.picture_series.splice(
        pic_index + d,
        0,
        c.picture_series.splice(pic_index, 1)[0]
      );
    },
    update_pic(axe, pic_index, picture) {
      axe.picture_series = axe.picture_series.map((p, i) =>
        i === pic_index ? picture : p
      );
    },
    delete_pic(axe, pic_index) {
      axe.picture_series = axe.picture_series.filter((_, i) => i !== pic_index);
    },
    async save() {
      this.loading = 1;
      await this.$store.dispatch(ltypes.SET_AXES_DETAILS, this.axes_map);
      this.loading = 0;
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>
